// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__EYpJU","tabs":"Toolbar_tabs__2X-DW","active":"Toolbar_active__1dn1V"};